import { apiService } from "../axiosService";

export const getApplicationUsersApi = async ({ orgId, signal } = {}) => {
  const response = await apiService.get(`/org/${orgId}/users`, { signal });
  return response;
};
